import { Controller } from '@hotwired/stimulus';

const TICK_MS = 65;
const TICKS = 17;

// The /formulas hero reel. Same spin as tutorial_reel_controller, but the list
// is alphabetical, so the outer rows are the landed formula's true neighbours
// and all three rows are their own links. Server-rendered first, so it still
// works with JS off; this only takes over on click.
export default class extends Controller {
  static targets = ['prev', 'current', 'next', 'name', 'short'];
  static values = { formulas: Array, index: Number };

  connect() {
    this.index = this.indexValue;
    this.spinning = false;
  }

  disconnect() {
    this.stop();
  }

  spin() {
    if (this.spinning || this.formulasValue.length === 0) return;

    this.spinning = true;
    this.setSpinningStyles(true);

    let ticks = 0;
    this.timer = setInterval(() => {
      ticks += 1;
      this.index = (this.index + 1) % this.formulasValue.length;

      if (ticks >= TICKS) {
        this.stop();
        // Land somewhere random rather than however far the ticks happened to walk.
        this.index = Math.floor(Math.random() * this.formulasValue.length);
        this.spinning = false;
        this.setSpinningStyles(false);
      }

      this.render();
    }, TICK_MS);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  setSpinningStyles(on) {
    this.rows.forEach((row) => {
      row.style.filter = on ? 'blur(1.2px)' : '';
      // Nothing to click until it lands, or you jump to whatever flashed past.
      row.style.pointerEvents = on ? 'none' : '';
    });
    [this.prevTarget, this.nextTarget].forEach((row) => {
      row.style.opacity = on ? '0.35' : '';
    });
  }

  render() {
    const list = this.formulasValue;
    if (list.length === 0) return;

    const at = (offset) => list[(this.index + offset + list.length) % list.length];

    const previous = at(-1);
    const landed = at(0);
    const upcoming = at(1);

    this.prevTarget.textContent = previous.name;
    this.prevTarget.href = previous.path;

    this.nameTarget.textContent = landed.name;
    this.shortTarget.textContent = landed.short;
    this.currentTarget.href = landed.path;

    this.nextTarget.textContent = upcoming.name;
    this.nextTarget.href = upcoming.path;
  }

  get rows() {
    return [this.prevTarget, this.currentTarget, this.nextTarget];
  }
}
